import React, { useEffect, useCallback, useState} from 'react';
import Documented from 'components/help/Documented.js';
import {ENVELOPE_TOGGLE} from 'constants/contextual-help.js';
import {connect} from 'react-redux';

const EnvelopeOptions = ({track, className=""}) => { 
    let {sequencerEngine} = track;
    let envelopes = sequencerEngine.envelopes;

    const toggleEnv = useCallback((env) => {
        if (track.isConnectedToEnvelope(env)) {
            track.disconnectFromEnvelope(env);
        } else {
            track.connectToEnvelope(env);
        }
    }, [track]);

    return (
        <div className={className + " envelope-options"}>
        {envelopes.map(
            env => <EnvelopeOption
                     key={env.number}
                     envelope={env}
                     onClick={() => toggleEnv(env)}
                     isConnected={track.isConnectedToEnvelope(env)}/>)}
        </div>
    );
}

const EnvelopeOption = ({envelope, isConnected, onClick}) => {
    let className = "envelope-option";
    if (isConnected) {
        className += " connected";
    }
    return (
        <Documented
          onClick={onClick}
          element={ENVELOPE_TOGGLE} arg={envelope.number} className={className}>
          ENV {envelope.number}</Documented>
    );
};

const mapStateToProps = (state, props) => {
    return {
        envelopes: state.tracks.trackEnvelopes[props.track.id]
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnvelopeOptions);
